/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect } from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { Card, Icon, Select, Tooltip } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import '../../../scss/KPICardTheme.scss';
import CarbonEmissionHOC from './CarbonEmissionHOC/CarbonEmissionHOC';
import TooltipError from '../../../images/tooltipError.svg';
import CarbonEmissionHOCSiteSeparate from './CarbonEmissionHOC/CarbonEmissionHOCSiteSeparate';
import { ApiContext } from '../../../context/ApiContext';
import {
  EmaasSubscriptionType,
  EnergyUsageDataSourceType
} from '../../shared/Enums';
import CarbonEmissionHOCSeparate from './CarbonEmissionHOC/CarbonEmissionHOCSeparate';

function CarbonEmissionKPI(props: IEnergyManagementProps) {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    carbonApiFor,
    dataSourceType,
    setDataSourceType
  } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const apiContext = useContext(ApiContext);

  const {
    cemsEnableCarbonSourceSelect,
    cemsIntervalEnergySourceOption
  } = apiContext;
  // const [dataSourceType, setDataSourceType] = React.useState<
  //   EnergyUsageDataSourceType | string | null
  // >(
  //   cemsEnableCarbonSourceSelect
  //     ? EnergyUsageDataSourceType.UTILITY_METER
  //     : null
  // );

  const isSitePremium =
    apiContext.toggleSeparateApi && apiContext.toggleFeatureScopeOne;

  return (
    <DataContextProvider config={connectorConfig}>
      <div className="carbon-container kpi-card-common">
        <Card>
          <Card.Header className="kpi-header-container">
            {/* <div style={{ marginRight: '5px' }} className="kpi-card-title">
              {t(d.CARBONEMISSION)}
            </div> */}
            <div className="kpi-card-title-wrapper" style={{ display: 'flex' }}>
              <div style={{ marginRight: '5px' }} className="kpi-card-title">
                {t(d.CARBONEMISSION)}
              </div>
              <Tooltip
                element={<Icon root="common" name="badge-info" size="small" />}
                event="hover"
                header={t(d.CARBONTOOLTIPHEADER)}
                // content={`${t(d.CARBONTOOLTIPCONTENT)}${t(
                //   d.CARBONTOOLTIPSECONDCONTENT
                // )}`}
                content={
                  requestContext.context.subscriptionType ===
                  'BASIC_SUBSCRIPTION'
                    ? `${t(d.CARBONTOOLTIPCONTENT)}${t(
                        d.CARBONTOOLTIPSECONDCONTENT
                      )}`
                    : cemsEnableCarbonSourceSelect
                    ? dataSourceType === EnergyUsageDataSourceType.UTILITY_METER
                      ? t(d.CARBONTOOLTIPSUTILITY)
                      : dataSourceType ===
                        EnergyUsageDataSourceType.UTILITY_INTERVAL
                      ? t(d.CARBONTOOLTIPINTRVAL)
                      : t(d.CARBONTOOLTIPLIVE)
                    : `${t(d.CARBONTOOLTIPCONTENT)}${t(
                        d.CARBONTOOLTIPSECONDCONTENT
                      )}`
                }
                position="right center"
                size="small"
              />
            </div>
            {/* <Tooltip
              element={<Icon root="common" name="badge-info" size="small" />}
              event="hover"
              header={t(d.CARBONTOOLTIPHEADER)}
              content={`${t(d.CARBONTOOLTIPCONTENT)}${t(
                d.CARBONTOOLTIPSECONDCONTENT
              )}`}
              position="right center"
              size="small"
            /> */}
            {cemsEnableCarbonSourceSelect && (
              <Select
                className="kpi-card-select cems-carbon-datasource-select"
                options={[
                  {
                    value: EnergyUsageDataSourceType.UTILITY_METER,
                    text: t(d.UTILITYPROVIDERNEW)
                  },
                  ...(cemsIntervalEnergySourceOption
                    ? [
                        {
                          value: EnergyUsageDataSourceType.UTILITY_INTERVAL,
                          text: t(d.UTILITYINTERVAL)
                        }
                      ]
                    : []),
                  {
                    value: EnergyUsageDataSourceType.LIVE_METER,
                    text: t(d.LIVEREADING)
                  }
                ]}
                value={dataSourceType}
                defaultValue={EnergyUsageDataSourceType.UTILITY_METER}
                onChange={(value: EnergyUsageDataSourceType) =>
                  setDataSourceType &&
                  setDataSourceType(value as EnergyUsageDataSourceType)
                }
              />
            )}
          </Card.Header>
          <Card.Content className="kpi-content-container siteview-progressbar">
            {isSitePremium ? (
              <CarbonEmissionHOCSeparate
                requestContext={requestContext}
                bearerToken={bearerToken}
                carbonApiFor={carbonApiFor}
                dataSourceType={dataSourceType}
              />
            ) : (
              <CarbonEmissionHOC
                requestContext={requestContext}
                bearerToken={bearerToken}
                carbonApiFor={carbonApiFor}
                dataSourceType={
                  dataSourceType as EnergyUsageDataSourceType | null
                }
                setDataSourceType={setDataSourceType}
              />
            )}
          </Card.Content>
        </Card>
      </div>
    </DataContextProvider>
  );
}

export default CarbonEmissionKPI;
